import Backblog from "../component/backblog/backblog"
import Cards from "../component/cards/card"
import Track from "../component/tracks/track"

function Blog(){
    return(
        <>
    <Backblog/>
    <Cards/>
    <Track/>
    
        </>
    )
}
export default Blog